import React, { useCallback, useContext, useEffect, useState } from "react";
import routePathSegments from "../../routeSegments";
import { NavLink, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { Tooltip } from "antd";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/config";
import NewLogo from "../NewLogo";
import SendDealPopUp from "../SendDealPopUp";
import addNoted from "../../images/AtomFavourite Copy/png/AtomFavourite Copy.png";
import { UserContext } from "../../Contexts/UserContext";
import linkedin from "../../Utils/linkedin.png";
import CompanyLogo from "../CompanyLogo";
import RandomLogo from "../RandomLogo";

const CSFDetailInfo = (props) => {
  const location = useLocation();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [companyData, setCompanyData] = useState({});
  const [isError, setIsError] = useState(false);
  const { getToken } = useContext(UserContext);

  const companyDetail = useCallback(() => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}/fundingRequest/${id}`, {
        headers: {
          Authorization: getToken(),
      }})
      .then((response) => {
        if (response.status === 200) {
          setCompanyData(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [companyData]);

    useEffect(() => companyDetail(), [id]);

    console.log(companyData?.pitch_doc_url, "companyData");

    const addToListHandler = () => {
      axios(`${baseUrl}/fundingRequest/addToList`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": getToken()
        },
        data: {
          entity_id: id
        }
      }).then((response) => {
        if(response.status === 200) {
          toast.success(response.data.message);
        }
      }).catch((error) => {
        toast.error(error.response.data.message);
      });
    };

  return isLoading && !isError ? (
    <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
      <table className="h-[10rem] w-full bg-[#FFFFFF] ">
        <center>
          <div role="status" className="bg-white  h-[16rem]">
            <svg
              className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </center>
      </table>
    </div>
  ) : !isError ? (
    <div id="detail-page" className="mt-12 overflow-y-auto">
      <div className="mb-2">
        <div className="bg-[#FFFFFF] relative">
          <nav
            className="flex p-1 lg:px-1 px-3 border-b "
            aria-label="Breadcrumb"
          >
            <ol className="flex items-center space-x-1">
              <li className="flex items-center">
                <div className="flex items-center">
                  <NavLink
                    to="/csf/companies"
                    className="ml-2 text-[11pt] lg:text-[12px] text-[#666666] font-sans_book_body"
                  >
                    Companies
                  </NavLink>
                </div>
              </li>
              <li className="flex items-center">
                <div className="flex items-center">
                  <span className=" text-[12px] text-[#666666] mr-1">/</span>
                  <span className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold">
                    {companyData?.company.registered_name}
                  </span>
                </div>
              </li>
            </ol>
          </nav>
        </div>
        <div>
          <ul>
              <li className="w-full flex p-4 bg-[#FFFFFF]">
                    <CompanyLogo id={companyData?.company?.id} name={companyData?.company?.registered_name} page="detail page" logo={"/"+companyData?.company?.logo_url} />                
                  <div className="ml-3 flex flex-1 flex-col">
                  <p className="text-[#333333] text-[22px] font-semibold leading-[24px]">
                      <span className="text-[22px] leading-[20px]">
                          {companyData?.company?.registered_name}
                      </span>
                  </p>
                  <span className=" text-[12pt] mt-[3px] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body ">
                      {companyData?.company?.industry}
                  </span>

                  <span className="text-[11pt] leading-[15pt]  text-[#777777] lg:text-[13px] font-sans_book_body lg:leading-[21px]">
                    {companyData?.company?.sector}
                  </span>
                </div>

                <div className="hidden lg:grid grid-cols-8 gap-2 ">
                  <div className="col-span-5 mt-[5px]">
                    <div className={"grid grid-cols-2 items-center gap-3"}>
                      <div className="col-span-1" onClick={() => addToListHandler()}>
                        <span>
                          <div>
                            <Tooltip title={"Add to List"}>
                            <img className={`cursor-pointer w-[24px] h-[22px]`}
                                src={addNoted}
                                alt=""
                            />
                            </Tooltip>
                          </div>
                        </span>
                      </div>
                      {/* <div className="col-span-1 mt-1">
                        <PENotesPopup
                          note={note}
                          cid={props.id}
                          type_id={Constants.moduleIds.companiesId}
                        />
                      </div> */}
                      <div className="col-span-1 mt-1">
                          <SendDealPopUp data={companyData?.name} />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
          </ul>
        </div>
      </div>
      <div className="m-4 flex gap-2">
        <div className="mx-2 bg-[#FFFFFF] w-1/2">
          <div className="p-4 flex justify-between">
            <h1 className="text-lg font-medium flex leading-[19pt] lg:text-[17px] text-[#333333]   lg:leading-[22px]">Company Profile 
              {companyData?.company?.linkedin && (
                <a href={companyData.company.linkedin} target="_blank" className="mt-[0.20rem] ml-2">
                  <img src={linkedin} width={16} alt="LinkedIn logo" />
                </a>
              )}
            </h1>
            <p className="text-xs text-gray-400">Last updated on {moment(companyData.updated_at).format("MMM DD, YYYY")}</p>
          </div>
          <div className="mt-4 px-4">
            <div className="flex border-b border-[#E0E0E0] py-4 text-base">
              <p className="min-w-[15rem] text-gray-700 ">CIN</p>
              <p>{companyData?.company?.cin}</p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Top Management</p>
              <p>{companyData?.name}</p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Location</p>
              <p>
                {companyData?.company?.city && companyData?.company?.country
                  ? `${companyData.company.city}, ${companyData.company.country}`
                  : companyData?.company?.city || companyData?.company?.country || '-'}
              </p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Email</p>
              <p>{companyData?.company?.email}</p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Contact</p>
              <p>{companyData?.company?.mobile}</p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Amount Sought (₹Cr)</p>
              <p>{companyData?.amount_sought}</p>
            </div>
            { companyData?.revenue === null || companyData?.revenue == '0' && (
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Revenue (₹Cr)</p>
              <p>{companyData?.revenue }</p>
            </div>
            )
            }
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Website</p>
              <p>
                {companyData?.company?.website ? (
                  <a href={companyData.company.website} target="_blank" rel="noopener noreferrer">
                    {companyData.company.website}
                  </a>
                ) : (
                  '-'
                )}
              </p>
            </div>
            <div className="flex border-b border-[#E0E0E0] py-4">
              <p className="min-w-[15rem] text-gray-700">Previously Funded</p>
              <p>{companyData?.previously_funded === 0 ? "No" : "Yes"}</p>
            </div>
          </div>
        </div>
        <div className="mx-2 bg-[#FFFFFF] w-1/2 h-[600px]">
          <iframe
            src={
              companyData?.pitch_doc_url?.includes(".pdf")
                ? companyData.pitch_doc_url
                : `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(companyData.pitch_doc_url)}`
            }
            className="w-full h-full"
          />
        </div>


      </div>
    </div>
  ) : (
    isError && (
      <div className="w-full h-full flex justify-center items-center">
        <h1>No Data Found for this company</h1>
      </div>
    )
  );
};

export default CSFDetailInfo;
